import { c as _c } from "react/compiler-runtime";
import { ChatBubbleLeftRightIcon } from "@heroicons/react/24/outline";
interface WaveDropsEmptyPlaceholderProps {
  readonly dropId: string | null;
}
export default function WaveDropsEmptyPlaceholder(t0) {
  const $ = _c(6);
  const {
    dropId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ChatBubbleLeftRightIcon className="tw-size-10 tw-text-iron-600" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className="tw-text-base tw-font-medium tw-text-iron-300">Start the conversation</p>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== dropId) {
    t3 = dropId && <p className="tw-text-sm tw-text-iron-500">Share your thoughts and join the discussion</p>;
    $[2] = dropId;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3) {
    t4 = <div className="tw-flex tw-items-center tw-justify-center tw-py-16 tw-px-4"><div className="tw-flex tw-flex-col tw-items-center tw-gap-4 tw-max-w-xs tw-text-center">{t1}<div className="tw-space-y-1.5">{t2}{t3}</div></div></div>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}